<template>
  <svg width="0" height="0" style="display: none;" v-html="$options.svgSprite" />
</template>

<script>
const svgContext = require.context(
  '!../../../assets/icons?raw', // search this directory and use 'raw' resourceQuery to use type: 'asset/source' (requires matching rule in webpack config)
  true, // search subdirectories
  /\w+\.svg$/i, // only include SVG files
);
const symbols = svgContext.keys()
  .filter(path => path.startsWith('.')) // filter out @virtual-peaker/vue-component-library prefixed paths
  .map((path) => {
    const content = svgContext(path); // get SVG file content
    const id = path.replace(/^\.\/(.*)\.\w+$/, '$1'); // extract icon id from filename

    // Replicate removeTags / removeSVGTagAttrs / removingTagAttrs from deprecated svg-inline-loader
    // Then replace svg tags with symbol tags and id attribute
    return content
      .split('>')
      .map(item => item.startsWith('<svg') ? item.replaceAll(/title=".*?"\s*|desc=".*?"\s*|defs=".*?"\s*|style=".*?"\s*|width=".*?"\s*|height=".*?"\s*/g, '') : item)
      .join('>')
      .replaceAll(/fill=".*?"/g, '')
      .replace('<svg', `<symbol id="${id}"`)
      .replace('svg>', 'symbol>');
  });
export default {
  name: 'VpSvgSprite',
  svgSprite: symbols.join('\n'), // concatenate all symbols into $options.svgSprite
};
</script>
